import React, { useContext } from "react";
import { Row, Col, Icon } from "antd";
import style from "./tabBar.module.scss";
import { NavLink } from "react-router-dom";
import { ContainerContext } from "App";
import {
    BiPen,
    BiNotepad,
    BiReceipt,
    BiBell,
    BiSolidChat
} from "react-icons/bi";
import { useAtomValue } from "jotai";
import { AllCountAtom } from "../../Stores/CommonStore";
import { useMount } from "react-use";
import { useUpdateNoticeCount } from "../../Utils/useUpdateNoticeCount";

const TabBar = () => {
    const { isInside } = useContext(ContainerContext);

    const num = useAtomValue(AllCountAtom);

    const updateCount = useUpdateNoticeCount();
    useMount(updateCount);

    if (isInside) {
        return null;
    }

    return (
        <div className={style.tabBar}>
            <Row>
                <Col span={4}>
                    <NavLink
                        to="/"
                        replace
                        exact
                        activeClassName={style.active}>
                        <BiNotepad />
                        <p>课程表</p>
                    </NavLink>
                </Col>

                <Col span={4}>
                    <NavLink
                        to="/homework"
                        replace
                        exact
                        activeClassName={style.active}>
                        <BiReceipt />
                        <p>作业</p>
                    </NavLink>
                </Col>

                <Col span={4}>
                    <NavLink
                        to="/exam"
                        replace
                        exact
                        activeClassName={style.active}>
                        <BiPen />
                        <p>考试</p>
                    </NavLink>
                </Col>

                <Col span={4}>
                    <NavLink
                        to="/askTeacher"
                        replace
                        exact
                        activeClassName={style.active}>
                        <BiSolidChat />
                        <p>答疑</p>
                    </NavLink>
                </Col>

                <Col span={4}>
                    <NavLink
                        to="/chat"
                        replace
                        exact
                        activeClassName={style.active}>
                        <Icon
                            type="message"
                            style={{ fontSize: "20px", verticalAlign: "3px" }}
                        />
                        <p>私信</p>
                    </NavLink>
                </Col>

                <Col span={4}>
                    <NavLink
                        to="/notice"
                        replace
                        exact
                        activeClassName={style.active}>
                        <BiBell />
                        <p style={{ position: "relative" }}>消息中心</p>
                        <div
                            className={style.badge}
                            style={{ display: num > 0 ? "block" : "none" }}>
                            <p>{num > 99 ? "99+" : num}</p>
                        </div>
                    </NavLink>
                </Col>
            </Row>
        </div>
    );
};

export default TabBar;
